import { objectToQueryString } from "common/utils/request/utils";

const addDTFProps = ($form, { formDtfSizes, formDtfImage }) => {
  $($form)
    .find("input[type=tel]")
    // eslint-disable-next-line func-names
    .each(function () {
      const quantity = $(this).val();
      if (quantity) {
        $(this).data("catalog-number", "Jiffy Transfers");
        $(this).data("color", "");
        $(this).data("size", `${formDtfSizes.width}” x ${formDtfSizes.height}”`);
        $(this).data("image", formDtfImage);
      }
    });
};

const createPayload = ($form, { dtfParams, madeParams }) => {
  // For DTF - only show artwork width x height in added popup.
  if (dtfParams?.formDtfSizes?.width && dtfParams?.formDtfSizes?.height) {
    addDTFProps($form, dtfParams);
  }

  let serializedData = $($form).serialize();
  if (madeParams.isMade) {
    const hash = objectToQueryString({ placements: madeParams.madePayload });
    serializedData += `&${hash}`;
  }

  return serializedData;
};

export default createPayload;
